/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as UserAccountActions from './user-account.actions';
import { initialState, IUserAccountState } from './user-account.state';

export const userAccountReducer = createReducer(
    initialState,
    on(
        UserAccountActions.fetchUserAccount,
        (state: IUserAccountState): IUserAccountState => ({
            ...state,
            loaded: false,
            loading: true,
        }),
    ),
    on(
        UserAccountActions.fetchUserAccountSuccess,
        (state: IUserAccountState, { payload }): IUserAccountState => ({
            ...state,
            userAccount: {
                ...payload,
            },
            loading: false,
            loaded: true,
        }),
    ),
    on(
        UserAccountActions.saveUserAccountSuccess,
        (state: IUserAccountState, { payload }): IUserAccountState => ({
            ...state,
            userAccount: {
                ...payload,
            },
            loading: false,
        }),
    ),
    on(
        UserAccountActions.fetchUserAccountError,
        UserAccountActions.saveUserAccountError,
        (state: IUserAccountState): IUserAccountState => ({
            ...state,
            loading: false,
        }),
    ),
);
